import { Element } from '../../types/drawing';

export function getElementById(elements: Element[], id: string): Element | null {
  return elements.find((el) => el.id === id) ?? null;
}

export function assertPresent<T>(value: T | null | undefined, message = 'Expected value to be present'): T {
  if (value === null || value === undefined) {
    throw new Error(message);
  }
  return value;
}

